<template>
  <header class="header">
    <img v-if="$regConfig.reg_cover" :src="$regConfig.reg_cover">
  </header>
</template>

<script>
export default {
  name: 'PageHeader'
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
